import * as React from 'react'
import { Box, Drawer } from '@mantine/core'
import { Header } from './Header'
import { NavbarContent } from './NavbarContent'

interface IProps {
  children: React.ReactNode
  opened: boolean
  onClose: () => void
}

export const NavbarDrawer = ({ children, opened, onClose }: IProps) => {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      size={300}
      styles={(theme) => ({
        content: {
          display: 'flex',
          flexDirection: 'column',
          boxShadow: theme.shadows.xs,
        },
      })}
    >
      <Header onNavLinkClick={onClose} />

      <Box className={'flex flex-1 overflow-hidden'}>
        <NavbarContent>{children}</NavbarContent>
      </Box>
    </Drawer>
  )
}
